import React from "react";
import { Paper, Typography, Divider, Grid } from "@mui/material";

const OrderBillingView = ({ order }) => {
  if (!order) {
    return <div>No order data available.</div>;
  }

  return (
    <Paper elevation={3} sx={{ padding: 3, marginTop: 3 }}>
      <Typography variant="h5" sx={{ mb: 2 }}>
        Billing Details
      </Typography>
      <Divider sx={{ mb: 2 }} />

      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body1" sx={{ mb: 1 }}>
            Billing Name: {order.billingName}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body1" sx={{ mb: 1 }}>
            Billing Contact: {order.billingContact}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body1" sx={{ mb: 1 }}>
            Billing Address: {order.billingAddress}
          </Typography>
        </Grid>
      </Grid>

      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body1" sx={{ mb: 1 }}>
            Billing Address 2: {order.billingAddress2}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body1" sx={{ mb: 1 }}>
            Billing City: {order.billingCity}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body1" sx={{ mb: 1 }}>
            Billing State: {order.billingState}
          </Typography>
        </Grid>
      </Grid>

      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body1" sx={{ mb: 1 }}>
            Billing Zip: {order.billingZip}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body1" sx={{ mb: 1 }}>
            Billing Phone: {order.billingPhone}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body1" sx={{ mb: 1 }}>
            Billing Fax: {order.billingFax}
          </Typography>
        </Grid>
      </Grid>

      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body1" sx={{ mb: 1 }}>
            Billing Email: {order.billingEmail}
          </Typography>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default OrderBillingView;
